import { useState } from "react";
import { NavLink } from "react-router-dom";
import navTabs from "../assets/navTabs";
import MainNavLink from "./MainNavLink";
import NavDropdown from "./NavDropdown";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const handleDropdownToggle = (id: string) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };

  const handleDropdownReset = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <nav className="relative bg-black w-full h-[78px] z-50 grid grid-cols-4 md:grid-cols-6 xl:grid-cols-12 gap-4 md:gap-6 xl:gap-8 justify-between items-center md:px-15 lg:px-20 xl:px-30 px-6">
      <NavLink to="/" className="col-span-1 z-10" onClick={handleDropdownReset}>
        <img
          className="w-10 md:w-12 2xl:w-14 3xl:w-15 my-3"
          src="/images/CultivLogo.svg"
          alt="cultiv logo"
          width={60}
          height={54}
        />
      </NavLink>
      <div className="flex md:hidden col-start-4 justify-self-end lg:px-6">
        <button
          onClick={() => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
            setActiveDropdown(null);
          }}
          type="button"
          className="text-white hover:text-white focus:outline-none focus:text-white"
          aria-label="toggle menu"
        >
          {isMobileMenuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 rotate-90 transition-transform duration-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 transition duration-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 8h16M4 16h16" />
            </svg>
          )}
        </button>
      </div>
      <ul
        className={`${
          isMobileMenuOpen
            ? "animate-nav-slide-down md:static"
            : "animate-nav-slide-up md:animate-none invisible md:visible duration-300 ease-in-out"
        } absolute md:static top-13 flex flex-col gap-4 bg-black px-6 md:px-0 pt-12 pb-6 md:pt-0 md:pb-0 w-full md:col-span-4 xl:col-span-5 xl:col-start-8 md:col-end-7 md:flex md:flex-row justify-between`}
      >
        {navTabs.map((navItem) => (
          <li key={navItem.to} className="relative cursor-pointer">
            <div
              className="relative"
              onMouseEnter={() => {
                if (!isMobileMenuOpen) setActiveDropdown(navItem.to);
              }}
              onMouseLeave={() => {
                setActiveDropdown(null);
              }}
            >
              <MainNavLink
                navItem={navItem}
                onMainClick={handleDropdownReset}
                onDropdownToggle={handleDropdownToggle}
                activeDropdown={activeDropdown}
              />
              <NavDropdown
                navItem={navItem}
                onClose={handleDropdownReset}
                activeDropdown={activeDropdown}
                isMobileMenuOpen={isMobileMenuOpen}
              />
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
}
